import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { AdminProvider } from "../contexts/AdminContext";
import { BranchProvider } from "../contexts/BranchContext";
import { DialogProvider } from "../contexts/DialogContext";

export const AdminComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <AdminProvider key={0} />,
        <BranchProvider key={1} />,
        <DialogProvider key={2} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
